import request from "@/yintai/utils/request";

export function fetchConfig(data) {
  return request({
    url: "/config/out/getById",
    method: "post",
    data,
  });
}
